import { defineRouting } from 'next-intl/routing';
import { DEFAULT_LOCALE, LOCALES } from '@mentorivo/shared/locales';

/**
 * Rota dilleri — liste `packages/shared/src/locales.ts`ten (13 dil, 29 Eyl 2026).
 *
 * Öneksiz bir adrese (`mentorivo.com/`, `/pricing`) gelen ziyaretçinin dili
 * next-intl'in katmanında seçiliyor: önce `NEXT_LOCALE` çerezi (kişinin daha
 * önce SEÇTİĞİ dil), yoksa tarayıcının `Accept-Language` başlığı, o da
 * eşleşmezse İngilizce. Yani cihazı Almanca olan biri siteyi ilk açışta
 * `/de`de buluyor; dil menüsünden başka bir dil seçerse çerez yazılıyor ve
 * bir sonraki gelişte o dil açılıyor.
 */
export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
});
